export default __webpack_public_path__ + "static/media/flash-off.363051be.svg";